"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CPaymentsCommissionsMap = void 0;
const shared_types_1 = require("@sigmasms/shared-types");
/**
 * В этом объекте может не быть коммиссии для какого-то метода оплаты
 */
exports.CPaymentsCommissionsMap = {
    [shared_types_1.PaymentMethods.tinkoff]: 3,
    [shared_types_1.PaymentMethods.mandarin]: 2.5,
    [shared_types_1.PaymentMethods.stripe]: 4
};
//# sourceMappingURL=payments.const.js.map